import React, { useState } from "react";

const buildStreaks = (count) =>
  Array.from({ length: count }).map((_, i) => ({
    id: i,
    top: `${10 + Math.random() * 80}%`,
    width: `${30 + Math.random() * 40}%`,
    duration: 9 + Math.random() * 8,
    delay: -Math.random() * 12,
  }));

export const LightStreaks = ({ count = 5, className = "" }) => {
  const [streaks] = useState(() => buildStreaks(count));

  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} aria-hidden>
      {streaks.map((s) => (
        <span
          key={s.id}
          className="streak"
          style={{
            top: s.top,
            width: s.width,
            animationDuration: `${s.duration}s`,
            animationDelay: `${s.delay}s`,
          }}
        />
      ))}
    </div>
  );
};

export default LightStreaks;
